import { useTranslation } from "react-i18next";

interface PageLoaderProps {
  /** Additional CSS classes for the container */
  className?: string;
}

/**
 * Full-width centered loading spinner with message.
 *
 * Used as the default loading state for pages that fetch data.
 */
export function PageLoader({ className = "mt-16" }: PageLoaderProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col items-center gap-3 ${className}`}>
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-indigo border-t-transparent" />
      <p className="text-sm text-muted">{t("common.loading")}</p>
    </div>
  );
}
